import React from 'react';
import {PendingProprietario} from "../../Proprietarios/FormProprietario/controller";
import {IonIcon, IonInput, IonItem, IonLabel} from "@ionic/react";
import {createOutline} from "ionicons/icons";

interface WidgetProprietarioProps {
  pendingInstance: PendingProprietario;
  disabled?: boolean;
  label: string;
  onClick: () => void;
}

const WidgetProprietario: React.FC<WidgetProprietarioProps> = (props) => {
  const {pendingInstance, disabled, label, onClick} = props;
  const {instance} = pendingInstance;

  return (
    <>
      <IonItem
        disabled={disabled}
        detail={false}
        button={true}
      >
        <IonLabel
          position="floating"
        >
          {label} *
        </IonLabel>
        <IonInput
          value={instance.nome}
          readonly={true}
        />
        <div className="flex flex-col justify-center h-full" slot="end">
          <IonIcon
            icon={createOutline}
            slot="end"
          />
        </div>
        <button
          className="absolute left-0 top-0 w-full h-full cursor-pointer bg-transparent appearance-none outline-none"
          style={{zIndex: 9999999}}
          onClick={(e: any) => {
            e.stopPropagation();
            e.preventDefault();
            onClick();
          }}
        />
      </IonItem>
    </>
  );
}

export default WidgetProprietario;
